export const createCardQuery = /* GraphQL */ `
    mutation {
        createCard {
            urlWebpay
            token
            status
            formkey
        }
    }
`

export interface CreateCardOutput {
    createCard: {
        urlWebpay: string
        token: string
        status: string
        formkey: string
    }
}
